export const ROLE_NAMES = {
  ADMIN: 'Administrator',
  SELF_SERVICE: 'Self Service',
  HR: 'HR',
  HR_ADMIN: 'HR Admin',
};
